var portfolioTransactionEdit = {
	title: "Modifier la transaction",
	subTitle: "Portefeuille: {name}",
	buy: "Achat",
	sell: "Vente",
	buyDate: "Date d'Achat",
	sellDate: "Date Vente",
	quantity: "Quantité/Nominal",
	buyPrice: "Prix d'Achat",
	exchangeRate: "Taux de Change",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Annuler",
	buyValueInPortfolioCurrency: "Valeur à l'achat (devise de portefeuille)",
	buyValueInNotationCurrency: "Valeur à l'achat (devise de notation)",
	sellValueInPortfolioCurrency: "Valeur à la vente (devise de portefeuille)",
	sellValueInNotationCurrency: "Valeur à la vente (devise de notation)",
	transactionType: "Type de Transaction",
	sellPrice: "Prix de Vente",
	validationErrors: {
		buyDate: {
			invalidInput: "Format de date non valide. Format valide yyyy-MM-dd'T'HH:mm"
		},
		buyPrice: {
			invalidInput: "Prix non valide"
		},
		exchangeRate: {
			invalidInput: "Taux de change non valide"
		},
		quantity: {
			invalidInput: "Quantité non valide"
		}
	}
};
var fr = {
	portfolioTransactionEdit: portfolioTransactionEdit
};

export { fr as default, portfolioTransactionEdit };
